<template>
  <v-card class="elevation-0 transparent">
    <v-card-text class="text-xs-center">
      <v-icon x-large :class="ui.textBlue1">{{info.icon}}</v-icon>
    </v-card-text>
    <v-card-title primary-title class="layout justify-center">
      <div :class="ui.textHeadline">{{info.title}}</div>
    </v-card-title>
    <v-card-text>
      <div :class="ui.textDescription">
        {{info.text}}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
export default {
  props: {
    info: {
      type: Object
    }
  },
  mixins: [apptheme]
};
</script>
